// extracted by mini-css-extract-plugin
export default {"icon":"EmailSubscriptionStatus_icon__bW8Ga"};